import { jsx as _jsx } from "react/jsx-runtime";
import { StyledLink } from "./styled";
const NavLink = ({ children, className, onClick, target, to }) => (_jsx(StyledLink, { className: className, onClick: onClick, target: target, to: to, children: children }));
export default NavLink;
